import React from "react";
import "./privacy_policy_page.css"
import Navbar from "./Navbar";
import FooterSection from "./footersection";


const PrivacyPolicyContent =  () =>{
    return(
        <div>
            <div className="terms-container">
                <div>
                    <h1>Privacy Policy - StockArchives</h1>
                    <p>
                        <strong>Effective Date:</strong> 09/05/2025
                    </p>
                    <p>
                        <strong>Last Updated:</strong> 09/05/2025
                    </p>
                </div>
                <div>
                    <p>
                        At StockArchives LLC, we respect your privacy and are
                         committed to protecting your personal information.
                    </p>
                </div>
                <div>
                <h2>1. Information We Collect</h2>
                <p>We may collect:</p>
                <ul>
                    <li>Personal information (e.g., name, email address) when you create an account</li>
                    <li>Technical data (e.g., browser type, IP address, usage stats)</li>
                    <li>API usage logs</li>
                </ul>
                </div>
                <div>
                    <h2>2. How We Use Your Information</h2>
                    <ul>
                        <li>To provide and maintain services</li>
                        <li>To monitor and analyze usage</li>
                        <li>To communicate with you about updates or offers</li>
                        <li>To detect and prevent abuse or fraud</li>
                    </ul>
                </div>
                <div>
                    <h2>3. Cookies and Tracking</h2>
                    <p>We use cookies to enhance user experience 
                        and monitor web traffic. You can disable cookies 
                        in your browser settings.</p>
                
                </div>
                <div>
                    <h2>4. Third-Party Services</h2>
                    <p>
                    We may use third-party services (e.g., analytics tools) 
                    to help operate our website. These services may collect 
                    limited technical data. 
                    </p>
                </div>
                <div>
                    <h2>5. Data Sharing</h2>
                    <p>We do not sell or rent your personal information. 
                        We may share it:</p>
                    <ul>
                        <li>With trusted service providers under confidentiality</li>
                        <li>If legally required (e.g., court order, subpoena)</li>
                    </ul>
                </div>
                <div>
                    <h2>6. Data Security</h2>
                    <p>We implement reasonable security measures to 
                        protect your data. However, no system is 100% secure, 
                        and we cannot guarantee absolute protection.</p>
                </div>
                <div>
                    <h2>7. Children’s Privacy</h2>
                    <p>Our services are not intended for users under 13. 
                        We do not knowingly collect personal information 
                        from children.</p>

                </div>
                <div>
                    <h2>8. Your Rights</h2>
                    <p>Depending on your jurisdiction, you may have 
                        rights to access, correct, or delete your data. 
                        To exercise these rights, contact: stockarchives0@gmail.com</p>
                </div>
                <div>
                    <h2>9. Changes to this Policy</h2>
                    <p>We may update this Privacy Policy periodically. 
                        We will notify you of significant changes through 
                        the website or email.</p>
                </div>
                <div>
                    <h2>10. Contact Us</h2>
                    <p>If you have questions, contact us at: stockarchives0@gmail.com</p>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicyContent;